/*
 * Implementation is https://koderlabs.github.io/ngx-device-detector/
 * but npm not used as issue with current angular version 4.x
 */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeviceDetectorService } from './services/device-detector.service';
import { ReTree } from './services/retree.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [

  ],
  exports: [
  ]
})
export class DeviceDetectorModule {
  static forRoot(): ModuleWithProviders<DeviceDetectorModule> {
    return {
      ngModule: DeviceDetectorModule,
      providers: [
        ReTree,
        DeviceDetectorService
      ]
    };
  }
}


export { DeviceDetectorService, DeviceInfo } from './services/device-detector.service';
export { ReTree } from './services/retree.service';
export * from './services/device-detector.constants';

